<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :headers="header"
      :get-data-func="getApplyList"
      ref="teacherList"
      hide-title-search
      @click:row="getDetails($event.item)"
      :init-pagination="{sortBy: 'creationTime', descending: true}"
      clickable
      :filter-items="filterItems">
      <template slot="title">
        <span class="pl-2 pr-4">业务部门审核</span>
        <v-btn flat color="primary"  :loading="loading" @click="outputExcel_2">数据导出</v-btn>
      </template>
      <template slot="filter:orgId">
        <v-autocomplete
          :items="searchSelects"
          v-model="filterItems[2].value"
          v-on:keyup="getSelection"
          prepend-icon="$vuetify.icons.group"
          label="所在单位"
          clearable
          hide-details
          hide-selected
          item-text="name"
          item-value="id"
        >
          <template slot="no-data">
            <v-alert :value="true" color="error">
              暂无单位信息
            </v-alert>
          </template>
          <template slot="item" slot-scope="props">
            <v-list-tile-content>
              <v-list-tile-title>
                <v-flex row align-center justify-between>
                  <span>{{props.item.name}}</span>
                </v-flex>
              </v-list-tile-title>
            </v-list-tile-content>
          </template>
        </v-autocomplete>
      </template>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-btn icon :disabled="item.secondAuditStatus+''!=='0'||!hasPermission" @click="review(item)">
            <v-icon>{{$vuetify.icons.edit}}</v-icon>
          </v-btn>
        </td>
      </template>
    </l-data-table>
  </l-layout>
</template>

<script>
  import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
  import {time} from "../../../ladmin/utils/time";
  import { exportExcel } from 'xlsx-oc'
  function reviewStatusTrans(v){
    switch (v+'') {
      case '1':return '已通过';
      case '2':return '已拒绝';
      case '0':return '待审核';
      case '-1':return 'N/A';
      default:return v;
    }
  }
  function reviewTypeTrans(v){
    if(v===null){
      return '职能部门审核'
    }
    switch (v+'') {
      case '1':return '科学研究类审核';
      case '2':return '本科生教学类审核';
      case '0':return '职能部门审核';
      case '3':return '研究生教学类审核';
      case '4':return '行政办公类';
      default:return v;
    }
  }
  export default {
    name: "secondReviewList",
    components: {LDataTable},
    data(){
      return {
        header:[
          {text:'教工姓名',value:'name',sortable:false,align:'left'},
          {text:'教工编号',value:'loginId',sortable:false,align:'left'},
          {text:'所在单位',value:'orgName',sortable:false,align:'left',placeholder:'N/A'},
          {text:'申请时间',value:'creationTime',sortable:false,align:'left',placeholder:'N/A',f:(v)=>time.stringify(v)},
          {text:'计划进校时间',value:'stTime',sortable:true,align:"left"},
          {text:'进校事由类别',value:'reviewType',sortable:false,align:'left',f:(v)=>reviewTypeTrans(v)},
          {text:'进校事由详述',value:'reqComment',sortable:true,align:"left",maxWidth: '6em', tooltip: true},
          {text:'二级单位审核状态',value:'firstAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'业务部门审核状态',value:'secondAuditStatus',sortable:false,align:'left',f:(v)=>reviewStatusTrans(v)},
          {text:'',value:'',sortable:false,align:'left'}
        ],
        selected:[],
        loading:false,
        hasPermission:false,
        searchSelects:[],
        amount:0,
        fileName:"业务部门审核数据导出表.xlsx",
        fileHeader:[
          { k: 'name', v: '教工姓名' },
          { k: 'loginId', v: '教工编号' },
          { k: 'orgName', v: '所在单位' },
          { k: 'creationTime', v: '申请时间' },
          { k: 'stTime', v: '计划进校时间' },
          { k: 'reviewType', v: '进校事由类别' },
          { k: 'reqComment', v: '进校事由详述' },
          { k: 'firstAuditStatus', v: '二级单位审核状态' },
          { k: 'secondAuditStatus', v: '业务部门审核状态' },
        ],
        filterItems: [
          {
            prependIcon: '$vuetify.icons.person',
            key: 'name',
            value: '',
            label: '教工姓名',
            type: 'input',
            layout: ['xs12', 'sm4'],
          },
          {
            prependIcon: '$vuetify.icons.person',
            key: 'loginId',
            value: '',
            label: '教工编号',
            type: 'input',
            layout: ['xs12', 'sm4'],
          },
          {
            prependIcon: '$vuetify.icons.group',
            key: 'orgId',
            value: '',
            label: '所在单位',
            type: 'input',
            layout: ['xs12', 'sm4'],
          },
          {
            key: 'creationTime',
            value: {},
            label: '申请时间',
            type: 'duration',
            layout: ['xs12', 'sm4'],
            f: v => v ? [time.toTimeStamp(v.startDatetime) || 0, time.toTimeStamp(v.endDatetime) || 9999999999999] : [0, 9999999999999],
            range: true
          },
          {
            prependIcon: '$vuetify.icons.location',
            key: 'secondAuditStatus',
            value: '',
            label: '业务部门审核状态',
            type: 'select',
            items:[{
              value:'0',
              text:'待审核'
            },
              {
                value:'1',
                text:'已通过'
              },
              {
                value:'2',
                text:'已拒绝'
              },],
            itemValue:'value',
            itemText:'text',
            layout: ['xs12', 'sm4'],
          },
        ],
      }
    },
    computed:{
      curOrg(){
        return this.$store.state.login.currentOrg
      }
    },
    methods:{
      dealPermission(filter){
        let permission = this.$store.state.login.permission
        console.log(permission)
        if(permission.temp===undefined){
          return filter
        }
        if(permission.temp.graduateAdmin!==undefined){
          filter.push({key:'reviewType',value:'3'})
          filter.push({key:'firstAuditStatus',value:'1'})
          this.hasPermission = true
        }else if(permission.temp.scienceAdmin!==undefined){
          filter.push({key:'reviewType',value:'1'})
          filter.push({key:'firstAuditStatus',value:'1'})
          this.hasPermission = true
        } else if(permission.temp.undergraduateAdmin!==undefined){
          filter.push({key:'reviewType',value:'2'})
          filter.push({key:'firstAuditStatus',value:'1'})
          this.hasPermission = true
        }else if(permission.temp.agentAdmin!==undefined){
          filter.push({key:'reviewType',value:'4'})
          filter.push({key:'firstAuditStatus',value:'1'})
          this.hasPermission = true
        }
        return filter
      },
      async getApplyList({pagination,filterItems}){
        let filter = [
          {key:'auditType',value:'0'}
        ]
        filter = this.dealPermission(filter)
        filter = [...filter,...filterItems]
        let {items,amount} = await this.$store.dispatch('school/getApplyList',{pagination:pagination,filter:filter})
        for(let i=0;i<items.length;i++){
          let item = items[i]
          if(item.firstAuditStatus+''==='0'||item.firstAuditStatus+''==='2'){
            item.secondAuditStatus = '-1'
          }
        }
        this.amount = amount
        return {items:items,amount:amount}
      },
      review(item){
        this.$router.push({name:'secondReviewDetailBox',
          query:{
            id:item.id,
            type:'2'
          }
        })
      },
      getDetails(item){
        if(item.firstAuditStatus+''==='0'||item.secondAuditStatus+''!=='0') {
          this.$router.push({name:'ApplyReviewDetailBox',
            query:{
              id:item.id,
              status:'readonly'
            }
          })
        }else{
          this.$router.push({name:'ApplyReviewDetailBox',
            query:{
              id:item.id,
              status:'review',
              type:'2'
            }
          })
        }
      },
      async getSelection (param) {
        let search = (param === undefined) ? '' : param.target.value
        let pagination = {page: 0, rowsPerPage: 10}
          let params = {
            'searchParam': {
              'name': {
                'index': '1',
                'order': 'DESC',
                'operators': [
                  {
                    'keyword': search,
                    'operator': 'LIKE',
                    'matchType': 'BOTH'
                  }
                ]
              }
            }
          }
          let res = await this.$store.dispatch('reservationConfig/getGroups', {param: params, pagination: pagination})
          if (res.data.status === 1) {
            this.searchSelects = res.data.data.content
          }
          else {
            this.searchSelects = []
          }

      },
      async outputExcel(){
        let pagination = {
          page:1,
          rowsPerPage: this.amount
        }
        let filter = [
          {key:'auditType',value:'0'}
        ]
        filter = this.dealPermission(filter)
        filter = [...filter,...this.filterItems]
        let {items,amount} = await this.$store.dispatch('school/getApplyList',{pagination:pagination,filter:filter})
        for(let i=0;i<items.length;i++){
          let item = items[i]
          if(item.firstAuditStatus+''==='0'||item.firstAuditStatus+''==='2'){
            item.secondAuditStatus = '-1'
          }
          item.firstAuditStatus = reviewStatusTrans(item.firstAuditStatus)
          item.secondAuditStatus = reviewStatusTrans(item.secondAuditStatus)
          item.reviewType = reviewTypeTrans(item.reviewType)
          item.creationTime = time.stringify(item.creationTime)
        }
        let list = []
        list = items
        if(list.length === 0){
          this.$L.alert('error',{message:'未查询到数据无法导出'})
        }else{
          exportExcel(this.fileHeader, list, this.fileName)
        }
        this.loading = false
      },
      async outputExcel_2(){
        let pagination = {
          page:1,
          rowsPerPage: this.amount
        }
        let filter = [
          {key:'auditType',value:'0'}
        ]
        filter = this.dealPermission(filter)
        filter = [...filter,...this.filterItems]
        let {items,amount} = await this.$store.dispatch('school/getApplyList',{pagination:pagination,filter:filter})
        for(let i=0;i<items.length;i++){
          let item = items[i]
          if(item.firstAuditStatus+''==='0'||item.firstAuditStatus+''==='2'){
            item.secondAuditStatus = '-1'
          }
          item.firstAuditStatus = reviewStatusTrans(item.firstAuditStatus)
          item.secondAuditStatus = reviewStatusTrans(item.secondAuditStatus)
          item.reviewType = reviewTypeTrans(item.reviewType)
          item.creationTime = time.stringify(item.creationTime)
        }
        let list = []
        const ExportJsonExcel = require('js-export-excel')
        let option = {}
        items.forEach((item)=>{
          let arr = []
          for(let i in this.fileHeader){
            arr.push(item[this.fileHeader[i].k])
          }
          list.push(arr)
        })
       // console.log(list)
        option.fileName = "业务部门审核数据导出表"
        option.datas=[
          {
            sheetData:list,
            sheetName:'sheet',
            sheetHeader:['教工姓名','教工编号','所在单位','申请时间','计划进校时间','进校事由类别','进校事由详述','二级单位审核状态','业务部门审核状态'],
          },
        ];
        let toExcel = new ExportJsonExcel(option); //new
        toExcel.saveExcel(); //保存
        this.loading = false
      },
    }
  }
</script>

<style scoped>

</style>
